<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>商品中心</el-breadcrumb-item>
            <el-breadcrumb-item>商家审核通过商品</el-breadcrumb-item>
        </el-breadcrumb>
        <!--		:data="list"数据-->
        <el-table :data="list" border>
            <!--			这里 prop scope传值-->
            <el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>

            <el-table-column prop="id" label="ID"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column label="商品图片">
                <!--				商品的组件和插槽-->
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                        <img :src="scope.row.productImages" height="30" style="display: flex; margin-right: 5px;" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="weight" label="重量"></el-table-column>
            <el-table-column label="销售价">
                <!--			价格模板插槽	-->
                <template slot-scope="scope">
                    <el-tag size="small">{{scope.row.price}} 元</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="市场价">
                <!--			价格模板插槽	-->
                <template slot-scope="scope">
                    <el-tag size="small">{{scope.row.market_price}} 元</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="sn" label="编号"></el-table-column>
            <el-table-column prop="created_date" label="创建日期"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <!--					传ID过去修改-->
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)">查看</el-button>
                    <el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!--		页码-->
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'Menu',
        data() {
            return {
                // 商品数据
                list:[],
                isLoad:false,
                pageSize:20,
                total:0,
                page:1,
                thumb:[],
                number: 0,
            }
        },
        created() {
          //   this.loadList()
        },
        methods: {
            // 获取数据
            loadList(){
                if(this.isLoad){
                    return
                }
                this.isLoad = !this.isLoad
                //	将页码传到/Goods/index
                this.axios.post('/business/store/product/passListByPage',{
                    page: this.page,
                    limit: this.pageSize
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 后端返回的商品数据列表
                        this.list = res.data.records
                        this.total = res.data.total

                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            // 商品审核
            edit(id){
                this.$router.push({
                    path:'/Goods/unreviewedEdit.vue.html',
                    query:{
                        id:id
                    }
                });
            },
            del(id){
                if(this.isLoad){
                    return
                }
                this.isLoad = !this.isLoad
                // ajax删除 先将要删除数据的ID传过去  执行删除
                this.axios.delete('/store/product/deleteOne', {
                    data:{
                        id
                    }
                })
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '删除成功',
                            showClose:false
                        });
                        // 重新获取数据
                      //   this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            //sizeReload 共多少条为一页
            sizeReload(val){
                this.pageSize = val
              //   this.loadList()
            },
            // 前往第几页
            pageReload(val){
                this.page = val
              //   this.loadList()
            }
        }
    }
</script>
<style scoped>
</style>
